import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

class GatedRoute extends React.Component {
  getRenderFunction = props => {
    const { component: Component, hasAccess, redirectTo } = this.props;

    return hasAccess ? (
      <Component {...props} />
    ) : (
      <Redirect {...props} to={redirectTo} />
    );
  };

  render() {
    const { path } = this.props;

    return <Route path={path} render={this.getRenderFunction} />;
  }
}

GatedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  hasAccess: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
};

export default GatedRoute;



// WEBPACK FOOTER //
// ./src/modules/common/GatedRoute.js